module.exports = __webpack_public_path__ + "img/golden_line_up.50896fc4.png";